import type { Contact, ContactPayload } from '@/entities/contacts';
import type { ContactFormValues } from '../model/validation';

export const transformContactToForm = (contact: Contact): ContactFormValues => ({
  title: contact.title ?? '',
  name: contact.name,
  jobTitle: contact.jobTitle ?? '',
  address: contact.address ?? '',
  email1: contact.email1 ?? '',
  email2: contact.email2 ?? '',
  email3: contact.email3 ?? '',
  phone1: contact.phone1 ?? '',
  phone2: contact.phone2 ?? '',
  phone3: contact.phone3 ?? ''
});

/**
 * The whole contact, because `PUT` replaces every field: an emptied field goes as `null`, which is
 * how the backend clears it.
 */
export const transformFormToContact = (values: ContactFormValues, orgId: number): ContactPayload => ({
  title: values.title || null,
  name: values.name,
  jobTitle: values.jobTitle || null,
  address: values.address || null,
  email1: values.email1 || null,
  email2: values.email2 || null,
  email3: values.email3 || null,
  phone1: values.phone1 || null,
  phone2: values.phone2 || null,
  phone3: values.phone3 || null,
  orgId
});
